import React from 'react';
import { Phone, Clock, Shield, Award } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mock';

const HeroSection = ({ title, subtitle, brandColor }) => {
  const whatsappLink = `https://wa.me/55${companyInfo.whatsapp}?text=Olá! Gostaria de um orçamento.`;

  return (
    <section className="relative bg-gradient-to-br from-[#2B3990] via-[#1e2a6e] to-[#2B3990] text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#8DC63F] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#8DC63F] rounded-full filter blur-3xl translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#8DC63F]/20 text-[#8DC63F] px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Shield size={16} />
            Garantia de 3 meses em todos os serviços
          </div>

          {/* Main Title */}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            {title || 'Assistência Técnica em Osasco'}
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            {subtitle || 'Especialistas em conserto de celulares, tablets, notebooks e MacBooks. Atendimento rápido e peças de alta qualidade.'}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="bg-[#8DC63F] hover:bg-[#7ab635] text-white font-semibold px-8 py-6 text-lg w-full sm:w-auto">
                <Phone size={20} className="mr-2" />
                Orçamento Grátis via WhatsApp
              </Button>
            </a>
            <a href={`tel:${companyInfo.whatsapp}`}>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-[#2B3990] font-semibold px-8 py-6 text-lg w-full sm:w-auto">
                Ligar Agora: {companyInfo.whatsappFormatted}
              </Button>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            <div className="flex flex-col items-center p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <Clock size={32} className="text-[#8DC63F] mb-2" />
              <span className="font-bold text-xl">2 Horas</span>
              <span className="text-sm text-gray-300">Tempo Médio</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <Shield size={32} className="text-[#8DC63F] mb-2" />
              <span className="font-bold text-xl">3 Meses</span>
              <span className="text-sm text-gray-300">Garantia</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <Award size={32} className="text-[#8DC63F] mb-2" />
              <span className="font-bold text-xl">Original</span>
              <span className="text-sm text-gray-300">Peças</span>
            </div>
            <div className="flex flex-col items-center p-4 bg-white/10 rounded-lg backdrop-blur-sm">
              <Phone size={32} className="text-[#8DC63F] mb-2" />
              <span className="font-bold text-xl">Grátis</span>
              <span className="text-sm text-gray-300">Orçamento</span>
            </div>
          </div>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 50L48 45.8C96 41.7 192 33.3 288 29.2C384 25 480 25 576 33.3C672 41.7 768 58.3 864 62.5C960 66.7 1056 58.3 1152 50C1248 41.7 1344 33.3 1392 29.2L1440 25V100H1392C1344 100 1248 100 1152 100C1056 100 960 100 864 100C768 100 672 100 576 100C480 100 384 100 288 100C192 100 96 100 48 100H0V50Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;